import styled from 'styled-components';

export default styled.span`
  color: ${props => props.light ? "#fff" : props.dark ? "#333333" : "gray"};
  font-weight: bold;
  font-size: 1.1rem;
  text-decoration: none;
  transition: 250ms ease;
  margin-left: ${props => props.first ? "0" : "2rem"};
  
  &:visited {
    color: ${props => props.light ? "#fff" : props.dark ? "#333333" : "gray"};
  }

  &:hover {
    color: ${props => props.light ? "#fff" : props.theme.primaryColor};
    text-decoration: ${props => props.light && "underline"};
  }  

  @media(min-width: 992px) {
    margin-left: ${props => props.first ? "0" : "3rem"}; /* aumentada */
    color: ${props => props.light ? "rgba(255, 255, 255, .7)" : props.dark ? "#333333" : "gray"};
    
    &:hover {
      color: ${props => props.light ? "#fff" : props.theme.primaryColor};
      text-decoration: ${props => props.light && "none"};
    }
  }
`;